import { useQuery, gql } from '@apollo/client';

export const GET_OWN_WORKING_CONDITIONS = gql`
  query getOwnWorkingConditions($queryOptions: QueryOptionsInput) {
    getOwnWorkingConditions(queryOptions: $queryOptions) {
      collection {
        _id
        active
        employmentType
        contracts {
          hireDate
          contractType
          endDate
        }
        memberId
        companyId
        companyLocationId
        companyBusinessAddressId
        companyDepartmentId
        jobId
        jobSupervisorId
        occupationType
        mainOrSecondaryOccupation
        contractExpirationDate
        terminationDate
        lengthOfProbation
        probationType
        terminatedBy
        referencePeriod
        probationDate
        weeklyHours
        noticePeriod
        noticePeriodType
        paidVacation
        company {
          name
        }
        companyLocation {
          name
        }
        companyBusinessAddress {
          zipCode
          street
          city
          country
        }
        companyDepartment {
          name
          costCenter
        }
        job {
          title
        }
        jobSupervisor {
          supervisorJobTitle
          supervisorMember {
            profile {
              displayName
            }
          }
        }
      }
      totalCount
    }
  }
`;


export const useGetOwnWorkingConditions = () => {
  const { data, loading } = useQuery(GET_OWN_WORKING_CONDITIONS, {
    variables: {
      queryOptions: {},
    },
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getOwnWorkingConditions || {};

  return {
    loading,
    collection,
    totalCount,
  };
};
